var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-incomeexpense-item-add'},"title":_vm.$t('setting.income-expense-item.text')}}),(_vm.data)?_c('List',{attrs:{"dataList":_vm.data,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[],"fields":[ 
          ("name: " + (_vm.$t('setting.income-expense-item.name'))),
          ("name_en: " + (_vm.$t('setting.income-expense-item.name-en'))),
          ("type_name: " + (_vm.$t('setting.income-expense-item.type'))) ],"deletes":[_vm.deleted, null],"edit":{link: 'setting-incomeexpense-item-edit'},"filter":{
          search: ['income_expense_items.name', 'income_expense_items.name_en'],
          dropdown: [{
            title: 'setting.income-expense-item.type',
            field: 'income_expense_items.item_type_id',
            data: this.itemTypeData.data,
          }]
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }